import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "90c59324-8c2b-428b-a001-4b1efd68bd7c",
  publicId: "16",
  name: "Radiation of a plane surface",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
